import React from 'react'
import { Row, Col, Tabs, Tab, Form } from '@themesberg/react-bootstrap'
import { InlineLoader, SpinnerLoader } from '../../../../../components/Preloader'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedo } from '@fortawesome/pro-solid-svg-icons'
import { DateRangePickerWithoutInput } from '../../../../../components/DateRangePicker'
import useTopPlayers from '../../hooks/useTopPlayers'
import Winners from '../../../../../components/TopPlayers/Winners'
import Loosers from '../../../../../components/TopPlayers/Loosers'
import Depositors from '../../../../../components/TopPlayers/Depositors'
import DateOptionsFilter from '../../../../../components/DateOptionsFilter'
import PendingWithdrawal from '../../../../../components/TopPlayers/Withdrawal'

export default ({ selectedPortal = '', selectedClient = '', accordionState }) => {
  const {
    fetchDetails,
    setState,
    state,
    limit,
    loading,
    setLimit,
    playerData,
    dateOptions,
    selectedTab,
    setSelectedTab,
    setDateOptions
  } = useTopPlayers({ selectedPortal, selectedClient, accordionState })

  return (
    <>
      <Row className='border-bottom d-flex align-items-center justify-content-between mb-2 pb-2'>
        <Col>
          <button onClick={() => fetchDetails()} className='btn btn-sm btn-secondary d-flex align-items-center gap-1'>
            <span className='fs-7'>Refresh</span>
            {loading ? <SpinnerLoader /> : <FontAwesomeIcon style={{ fontSize: '15px' }} icon={faRedo} />}
          </button>
        </Col>

        <Col xs='auto'>
          <div className='d-flex justify-content-end align-items-center DateRangePickerWithoutInputWrapper'>
            {dateOptions === 'custom' &&
              <DateRangePickerWithoutInput
                state={state} setState={setState}
              />}

            <Form.Label style={{ width: '100px', marginTop: '5px', marginRight: '10px' }}>
              Date Options
            </Form.Label>
            <DateOptionsFilter dateOptions={dateOptions} setDateOptions={setDateOptions} setDateRange={setState} />

            <Form.Label style={{ marginLeft: '20px', marginTop: '5px', marginRight: '10px' }}>
              Limit
            </Form.Label>
            <Form.Select
              onChange={(e) => setLimit(e.target.value)}
              value={limit}
              style={{ maxWidth: '65px', marginRight: '10px' }}
              size='sm'
            >
              <option value='5'>5</option>
              <option value='10'>10</option>
              <option value='15'>15</option>
              <option value='20'>20</option>
              <option value='25'>25</option>
              <option value='50'>50</option>
              <option value='100'>100</option>
            </Form.Select>
          </div>
        </Col>
      </Row>

      <Tabs
        activeKey={selectedTab}
        onSelect={(tab) => setSelectedTab(tab)}
        className='nav-light dashboard'
      >
        <Tab eventKey='winners' title={`Top ${limit} Winners`}>
          <div className='mt-2'>
            <Row className='mt-4 d-flex flex-row-reverse text-right'>
              {loading
                ? <InlineLoader />
                : <Winners tableData={playerData?.topTenWinners || []} />}
            </Row>
          </div>
        </Tab>

        <Tab eventKey='loosers' title={`Top ${limit} Losers`}>
          <div className='mt-2'>
            <Row className='mt-4 d-flex flex-row-reverse text-right'>
              {loading
                ? <InlineLoader />
                : <Loosers tableData={playerData?.topTenLosers || []} />}
            </Row>
          </div>
        </Tab>

        <Tab eventKey='depositors' title={`Top ${limit} Depositors`}>
          <div className='mt-2'>
            <Row className='mt-4 d-flex flex-row-reverse text-right'>
              {loading
                ? <InlineLoader />
                : <Depositors tableData={playerData?.topTenDepositors || []} />}
            </Row>
          </div>
        </Tab>

        <Tab eventKey='withdrawal' title={`Top ${limit} Requests`}>
          <div className='mt-2'>
            <Row className='mt-4 d-flex flex-row-reverse text-right'>
              {loading
                ? <InlineLoader />
                : <PendingWithdrawal tableData={playerData?.pendingWithdrawals || []} />}
            </Row>
          </div>
        </Tab>
      </Tabs>

    </>

  )
}
